export const WORKFLOWS_FEATURES = {
  moduleKey: 'workflows',
  features: ['workflows.run', 'workflows.manage'] as const,
  featureMeta: {
    'workflows.run': {
      name: 'Run workflows',
      translations: { name: { de: 'Workflows ausführen', en: 'Run workflows', fr: 'Exécuter les workflows', it: 'Eseguire i workflow' } },
    },
    'workflows.manage': {
      name: 'Manage workflows',
      translations: { name: { de: 'Workflows verwalten', en: 'Manage workflows', fr: 'Gérer les workflows', it: 'Gestire i workflow' } },
    },
  },
} as const;
